<template>
  <div class="MemberHeader">
    <div class="logo"><img src="@/assets/img/logo2.png" alt="" /></div>
    <div class="text">
      <router-link target="_blank" class="blank" :to="{ path: '/' }">门户首页</router-link>
      <span>|</span>
      <span @click.stop="changePwd">修改密码</span>
      <span>|</span>
      <span @click.stop="quit()">注销</span>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    changePwd() {
      this.$router.push({
        path: '/ChangePassword'
      })
    },
    quit() {
      window.localStorage.removeItem('loginToken')

      this.$router.push({ path: '/' })
    }
  }
}
</script>

<style lang="scss" scoped>
.MemberHeader {
  display: flex;
  align-items: center;
  height: 60px;
  padding: 0 20px;
  background: #0660a2;
  .logo {
    flex: 1;
  }
  .text {
    color: #cccccc;
    a {
      color: #cccccc;
      text-decoration: none;
    }
    cursor: pointer;
    span {
      margin: 0 10px;
    }
  }
}
</style>
